// update.service.ts (Angular 12)
import { Injectable, NgZone } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval, fromEvent, merge } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UpdateService {
  private readonly CHECK_INTERVAL_MS = 30 * 60 * 1000; // 30 min

  constructor(private updates: SwUpdate, private zone: NgZone) {}

  init(onUpdateReady: () => Promise<boolean> | boolean) {
    if (!this.updates.isEnabled) return;

    // 1) När en ny version finns tillgänglig
    this.updates.available.subscribe(async () => {
      const shouldReload = await onUpdateReady();
      if (shouldReload) {
        // Angular 12: aktivera nya SW + reload för att ladda nya bundles säkert
        try {
          await this.updates.activateUpdate();
        } finally {
          location.reload();
        }
      }
    });

    // 2) Extra: logga när den aktiverats (valfritt)
    this.updates.activated.subscribe(() => {
      // t.ex. console.log('App updated');
    });

    // 3) Smart check: start + fokus + intervall
    this.checkNow();

    const visibility$ = fromEvent(document, 'visibilitychange').pipe(
      filter(() => document.visibilityState === 'visible')
    );

    // Kör interval utanför Angular så du inte triggar change detection i onödan
    this.zone.runOutsideAngular(() => {
      merge(visibility$, interval(this.CHECK_INTERVAL_MS)).subscribe(() => this.checkNow());
    });
  }

  async checkNow() {
    try {
      await this.updates.checkForUpdate();
    } catch {
      // offline/transient errors är ok att ignorera
    }
  }
}